// extracted by mini-css-extract-plugin
module.exports = {"FavoriteItem":"FavoriteItem_FavoriteItem__3ooyT","ImageFlag":"FavoriteItem_ImageFlag__fTmYH","Driver":"FavoriteItem_Driver__1DHYL"};